import { render } from "./RecomendacionesVendedor.vue?vue&type=template&id=212ab1f6"
import script from "./RecomendacionesVendedor.vue?vue&type=script&lang=js"
export * from "./RecomendacionesVendedor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__